// Add your JS customizations here
jQuery(function () {
    if (jQuery('.swiper-breaking').length) {

        var swiper = new Swiper(".swiper-breaking", {
            effect: "fade",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 1,
            // Aggiungo autoplay
            autoplay: {
                delay: 7000, // 3 secondi tra ogni slide
                disableOnInteraction: false, // continua l'autoplay anche dopo l'interazione dell'utente
            },
            // Aggiungo le frecce di navigazione
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }

    jQuery('.btn-consent').on('click', function (e) {
        jQuery.cookie('consent', '1', { expires: 30, path: '/' });
        jQuery('#modal-command-consent').modal('hide');
    });

    jQuery('.btn-preferenze').on('click', function () {
        // modal-dialog-preferenze
        var info = jQuery('.modal-dialog-info');
        var pref = jQuery('.modal-dialog-preferenze');
        info.hide();
        pref.show();
    });

    jQuery('.btn-preferenze-back').on('click', function () {
        // modal-dialog-preferenze
        var info = jQuery('.modal-dialog-info');
        var pref = jQuery('.modal-dialog-preferenze');
        info.show();
        pref.hide();
    });

});


jQuery(window).on('load', function () {
    var cookieCookie = jQuery.cookie('consent');
    if (!cookieCookie) {
        setTimeout(function () {
            jQuery('#modal-command-consent').modal('show');
        }, 5000);
    }
});


document.addEventListener('DOMContentLoaded', function() {
    // Seleziona l'icona di ricerca e il box overlay
    const searchIcon = document.querySelector('.icon-search').closest('a');
    const searchOverlay = document.querySelector('.search-overlay');
    const closeButton = document.querySelector('.btn-search-closed');
    
    // Funzione per mostrare il search overlay
    function showSearchOverlay() {
        searchOverlay.classList.remove('hidden');
        searchOverlay.classList.add('show');
        
        // Focus automatico sul campo di ricerca
        setTimeout(() => {
            document.querySelector('.search-field').focus();
        }, 100);
        
        
      
    }
    
    // Funzione per nascondere il search overlay
    function hideSearchOverlay() {
        searchOverlay.classList.remove('show');
        searchOverlay.classList.add('hidden');
        
        // Ripristina lo scrolling del body
        document.body.style.overflow = '';
    }
    
    // Aggiungi evento click all'icona di ricerca
    searchIcon.addEventListener('click', function(e) {
        e.preventDefault();
        showSearchOverlay();
    });
    
    // Aggiungi evento click al pulsante di chiusura
    closeButton.addEventListener('click', function() {
        hideSearchOverlay();
    });
    
    // Chiudi l'overlay quando si preme ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !searchOverlay.classList.contains('hidden')) {
            hideSearchOverlay();
        }
    });
});






